// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".AppStarter {\n  background-color: #272727;\n  color: #fff;\n  display: flex;\n  height: 100vh;\n  text-align: center;\n}\n\n.AppStarter img.logo {\n  margin: 2rem auto;\n  width: 100%;\n}\n\n.AppStarter .content {\n  margin: auto;\n  width: 25%;\n}\n", ""]);
// Exports
module.exports = exports;
